import { ACTION_OBJECT_TYPES } from 'actions/useActionsLibrary';

import FormHeader from 'components/global/FormHeader';
import { HeaderContainerFormHeader } from 'components/global/styled/FormHeader.styled';
import DynamicList from 'components/list/DynamicList';
import { FilterAction, FilterType, ListComponents } from 'components/list/DynamicListFilterUtils';

import { ENUMS, REPORT } from 'services/consts';

import { DYNAMICLISTS } from 'utils/constants';
import PATHS, { mergePaths } from 'utils/paths';

import { faArrowLeft } from '@fortawesome/pro-solid-svg-icons';

/**
 * @author Burak Ak
 */

export const ShipmentStatusReportConfig = {
	id: DYNAMICLISTS.SHIPMENT_STATUS_REPORT,
	columns: [
		{
			Header: 'id',
			accessor: 'ID',
			filterType: FilterType.number,
			width: 50,
			show: false,
			showCopyButton: true
		},
		{
			Header: 'otoOrderID',
			accessor: 'otoOrderID',
			filterType: FilterType.number,
			width: 50,
			showCopyButton: true
		},
		{
			Header: 'orderID',
			accessor: 'orderID',
			filterType: FilterType.string,
			width: 70,
			showOnMobile: true,
			showCopyButton: true
		},
		{
			Header: 'pickupLocation',
			accessor: 'pickupLocation',
			filterType: FilterType.enumMulti,
			enumName: ENUMS.PICKUP_LOCATION,
			width: 90
		},
		{
			Header: 'deliveryCompany',
			accessor: 'deliveryName',
			filterType: FilterType.enumMulti,
			width: 90,
			enumName: ENUMS.ACTIVE_DC_SETTINGS,
			renderCell: ListComponents.DC_LOGO
		},
		{
			Header: 'shipmentNumber',
			accessor: 'shipmentNumber',
			filterType: FilterType.number,
			width: 110,
			renderCell: ListComponents.TRACKING_URL
		},
		{
			Header: 'city',
			accessor: 'cityName',
			filterType: FilterType.multiSelection
		},
		{ Header: 'areaName', accessor: 'areaName', filterType: FilterType.string },
		{
			Header: 'orderDate',
			accessor: 'createdAt',
			filterType: FilterType.date,
			width: 100,
			renderCell: ListComponents.DATETIME,
			filterRemovable: false,
			customFilterOptions: [FilterAction.between, FilterAction.on]
		},
		{
			Header: 'orderTime',
			accessor: 'orderTime',
			filterType: FilterType.string,
			width: 80
		},
		{
			Header: 'shipmentCreatedDate',
			accessor: 'shipmentCreatedDate',
			filterType: FilterType.date,
			width: 100,
			renderCell: ListComponents.DATETIME
		},
		{
			Header: 'scheduledDate',
			accessor: 'scheduledDate',
			filterType: FilterType.string
		},
		{
			Header: 'firstDeliveryAttemptDate',
			accessor: 'firstDeliveryAttemptDate',
			filterType: FilterType.date,
			width: 100,
			renderCell: ListComponents.DATETIME
		},
		{
			Header: 'deliveryDate',
			accessor: 'deliveryDate',
			filterType: FilterType.date,
			width: 100,
			renderCell: ListComponents.DATETIME
		},
		{
			Header: 'deliveredTime',
			accessor: 'deliveredTime',
			filterType: FilterType.string
		},
		{
			Header: 'undeliveredAttemptCnt',
			accessor: 'undeliveredAttemptCnt',
			filterType: FilterType.number,
			width: 80
		},
		{
			Header: 'comment',
			accessor: 'failedDeliveryComment',
			filterType: FilterType.string
		},
		{
			Header: 'deliverySlotSLA',
			accessor: 'deliverySlotSLA',
			filterType: FilterType.enumMulti,
			enumName: ENUMS.YES_NO
		},
		{
			Header: 'sameDay',
			accessor: 'sameDay',
			filterType: FilterType.enumMulti,
			enumName: ENUMS.YES_NO
		},
		{
			Header: 'hourDelay',
			accessor: 'hourDelay',
			filterType: FilterType.string
		},
		{
			Header: 'status',
			accessor: 'status',
			renderCell: ListComponents.STATUS,
			filterType: FilterType.enumMulti,
			enumName: ENUMS.ALL_STATUSES,
			filterPrefix: 'status.',
			width: 100,
			showOnMobile: true
		},
		{
			Header: 'packageSize',
			accessor: 'maxPackageSize',
			filterType: FilterType.string
		},
		{
			Header: 'deliverySLA',
			accessor: 'deliverySLA',
			filterType: FilterType.number
		},
		{
			Header: 'shipmentDuration',
			accessor: 'shipmentDuration',
			filterType: FilterType.string
		},
		{
			Header: 'ref2',
			accessor: 'ref2',
			filterType: FilterType.string
		},
		{
			Header: 'ref3',
			accessor: 'ref3',
			filterType: FilterType.string
		}
	],
	fetchUrl: REPORT.LIST.GET_SHIPMENT_STATUS_LIST,
	defaultSort: [{ id: 'createdAt', desc: true }],
	exportName: 'shipmentStatusReport',
	actionObjectType: ACTION_OBJECT_TYPES.SUPPORT
};

const ShipmentStatusReport = () => (
	<div>
		<HeaderContainerFormHeader>
			<FormHeader
				lightTitle="reports"
				boldTitle="shipmentStatusReport"
				icon={faArrowLeft}
				backUrl={mergePaths(PATHS.REPORTS, PATHS.SHIPMENT_REPORTS)}
			/>
		</HeaderContainerFormHeader>

		<DynamicList {...ShipmentStatusReportConfig} infiniteScroll />
	</div>
);

export default ShipmentStatusReport;
